import { DatePipe } from '@angular/common';
import { Component, ElementRef } from '@angular/core';
import { FnCheckboxFilterItem, FnTabModel, FnToasterService, FnUtilService } from 'foundation';
import { PosHttpService } from '../../services/pos.http.service';
import { EOSchema } from '../../modal/entity.modal';
import { OfflineClockService } from './offline-clock.service';
import { AppRestartService } from './app-restart.service';
import { ContextEventService } from './context-event.service';
import { LoginDataService } from './login-data.service';
import { SiteClockService } from './site-clock.service';
import { HourlyGraphsService } from './hourly-graphs.service';
import { DailyGraphsService } from './daily-graphs.service';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-health-monitoring',
  templateUrl: './health-monitoring.component.html',
  styleUrl: './health-monitoring.component.scss'
})
export class HealthMonitoringComponent {
  constructor(public datepipe: DatePipe, private elementRef: ElementRef, private fnutilservice: FnUtilService, private posHttpSvcs: PosHttpService, private toaster: FnToasterService,
    private loginDataService: LoginDataService, private offlineClockService: OfflineClockService, private hourlyGraphsService: HourlyGraphsService,
    private dailyGraphsService: DailyGraphsService, private appRestartService: AppRestartService, private siteClockService: SiteClockService,
    private contextEventService: ContextEventService) { }

  ngOnInit() {
    this.dateRangeObject.startDate.setDate(this.currentDate.getDate());
    this.dateRangeObject.endDate.setDate(this.currentDate.getDate());
    this.startDate = this.datepipe.transform(this.dateRangeObject.startDate, 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(this.dateRangeObject.endDate, 'yyyy-MM-dd');
    this.loadMetaData();

    const now = new Date();

    const formatted = `${(now.getMonth() + 1).toString().padStart(2, '0')}/` +
      `${now.getDate().toString().padStart(2, '0')}/` +
      `${now.getFullYear()} ` +
      `${now.getHours().toString().padStart(2, '0')}:` +
      `${now.getMinutes().toString().padStart(2, '0')}:` +
      `${now.getSeconds().toString().padStart(2, '0')}`;

    this.timeEvent = formatted;
  }

  loadMetaData() {
    this.posHttpSvcs.authGet('v1/ui/getMetaData', 'getMetaData').subscribe((resp => {
      if (resp.isError) {
        this.toaster.error("Error in Loading MetaData");
        return;
      }
      const array = resp.data?.schema || [];
      array.forEach((data: EOSchema) => {
        this.schemaArray.push({ id: `${data.name}`, description: data.friendlyName, isSelected: undefined });
      });
      const clockarray = resp.data.schema;
      clockarray.forEach((data: EOSchema) => {
        this.clockSchemaArray.push({ id: `${data.name}`, description: data.name, isSelected: undefined });
      })
      const appArr = resp.data.appArray;
      appArr.forEach((data: EOSchema) => {
        this.appArray.push({ id: `${data.name}`, description: data.friendlyName, isSelected: undefined });
      })
      this.eventArray = resp.data.event;
      this.hostEventArray = resp.data.hostEvent;
      this.dailySchemaArray = array.map((data: EOSchema) => ({
        id: `${data.name}`,
        description: data.name,
        isSelected: undefined
      }));
    }))
  }

  schemaArray: Array<FnCheckboxFilterItem> = [];
  dailySchemaArray: Array<FnCheckboxFilterItem> = [];
  clockSchemaArray: Array<FnCheckboxFilterItem> = [];
  appArray: Array<FnCheckboxFilterItem> = [];
  eventArray: any = {};
  defaultDesc: string = 'Select Schema';
  currentDate = new Date();
  selectedDay = 2;
  selectedDayMin = 1;
  selectedDayMinValue: any;
  selectedHour = 2;
  isLoading: boolean = false;
  hostWise = false;
  customDate = false;
  maxDateRange = new Date();
  startDate: any;
  endDate: any;
  selectedSchema: string[] = [];
  selectedDailySchema: any;
  selectedApp: string[] = [];
  chartView = false;
  selectedEvent: any;
  siteChartView = false;
  selectedRange = '2Weeks';
  hostEventArray: any = {};
  selectedHostEvent: any;
  hostwise = false;
  selectedClock = 30;

  get hasChartData(): boolean {
    return Object.keys(this.chartData).length > 0;
  }

  dateRangeObject = {
    startDate: new Date(),
    endDate: new Date()
  };

  changeDate(event: any) {
    this.startDate = this.datepipe.transform(event.startDate, 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(event.endDate, 'yyyy-MM-dd');
  }

  selectSchema(event: any) {
    if (event.size === 0) {
      this.selectedSchema = [];
      return;
    }
    this.selectedSchema = Array.from(event.keys());
  }

  selectApp(event: any) {
    if (event.size === 0) {
      this.selectedApp = [];
      return;
    }
    this.selectedApp = Array.from(event.keys());
  }

  chartData: { [key: string]: ChartDataPoint[] } = {};

  clockStatusData: ClockStatusReport[] = [];

  clockData: ClockStatusReport[] = [];

  hourlyData: any[] = [];

  siteClockData: SiteClockReport[] = [];

  dailyData: any[] = [];

  hostData: any[] = [];

  appRestartData: AppRestartReport[] = [];
  appRestartHost: HostRestartReport[] = [];

  hostWiseGraphData: any[] = [];
  chartDataGraph: any[] = [];
  schemaGraphData: { schema: string; timeWise: any[]; hostWise: any[] }[] = [];

  showModal: boolean = false;
  showSchemaModal: { [schema: string]: boolean } = {};
  modalData: { hostName: string; count: number }[] = [];

  clockGraph: any[] = [];
  siteGraph: any[] = [];

  dayArray = [
    { "key": 1, "value": "1 hour" },
    { "key": 2, "value": "2 hour" },
    { "key": 3, "value": "3 hour" },
    { "key": 6, "value": "6 hour" },
    { "key": 8, "value": "8 hour" },
    { "key": 12, "value": "12 hour" },
    { "key": 18, "value": "18 hour" },
    { "key": 24, "value": "24 hour" }
  ]

  dayRangeArray = [
    { 'key': '2Weeks', 'value': 'Last 2 Weeks' },
    { 'key': '4Weeks', 'value': 'Last 4 Weeks' },
    { 'key': '6Weeks', 'value': 'Last 6 Weeks' },
    { 'key': 'Sunday', 'value': 'Last 10 Sunday' },
    { 'key': 'Monday', 'value': 'Last 10 Monday' },
    { 'key': 'Tuesday', 'value': 'Last 10 Tuesday' },
    { 'key': 'Wednesday', 'value': 'Last 10 Wednesday' },
    { 'key': 'Thursday', 'value': 'Last 10 Thursday' },
    { 'key': 'Friday', 'value': 'Last 10 Friday' },
    { 'key': 'Saturday', 'value': 'Last 10 Saturday' }
  ];

  minHourArray = [
    { "key": 15, "value": "15 Minutes" },
    { "key": 30, "value": "30 Minutes" },
    { "key": 45, "value": "45 Minutes" },
    { "key": 60, "value": "1 hour" },
    { "key": 120, "value": "2 hour" },
    { "key": 180, "value": "3 hour" },
    { "key": 360, "value": "6 hour" },
    { "key": 480, "value": "8 hour" },
    { "key": 720, "value": "12 hour" },
    { "key": 1080, "value": "18 hour" },
    { "key": 1440, "value": "24 hour" }
  ]

  tabArray: FnTabModel[] = [
    { id: 'tab_1', titile: 'Login Avg', templateId: 'data_1' },
    { id: 'tab_2', titile: 'Offline Clock', templateId: 'data_2' },
    { id: 'tab_4', titile: 'Advance Offline Clock', templateId: 'data_4' },
    { id: 'tab_3', titile: 'Hourly Graphs', templateId: 'data_3' },
    { id: 'tab_5', titile: 'Daily Graphs', templateId: 'data_5' },
    { id: 'tab_6', titile: 'App Restart', templateId: 'data_6' },
    { id: 'tab_7', titile: 'Site Offline Clock', templateId: 'data_7' },
    { id: 'tab_9', titile: 'Context Event Graph', templateId: 'data_9' },
  ];

  hourDayArray = [
    { "key": 1, "value": "1 hour" },
    { "key": 2, "value": "2 hour" },
    { "key": 3, "value": "3 hour" },
    { "key": 6, "value": "6 hour" },
    { "key": 8, "value": "8 hour" },
    { "key": 12, "value": "12 hour" },
    { "key": 18, "value": "18 hour" },
    { "key": 24, "value": "24 hour" },
    { "key": 48, "value": "2 days" },
    { "key": 72, "value": "3 days" },
    { "key": 96, "value": "4 days" },
    { "key": 120, "value": "5 days" },
    { "key": 144, "value": "6 days" },
    { "key": 168, "value": "7 days" }
  ]

  isSchemaHighlighted(schema: string): boolean {
    const highlightedSchemas = this.clockStatusData.map(item => item.schemaID);
    return highlightedSchemas.includes(schema);
  }

  get totalRow(): ClockStatusReport {
    const validData = this.clockStatusData.filter(Boolean);

    const totalCount = validData.reduce((sum, item) => sum + item.totalCount, 0);
    const onlineCount = validData.reduce((sum, item) => sum + item.onlineCount, 0);
    const offlineCount = validData.reduce((sum, item) => sum + item.offlineCount, 0);
    const perOffline = totalCount ? parseFloat(((offlineCount / totalCount) * 100).toFixed(2)) : 0;

    return {
      schemaID: 'Total',
      totalCount,
      onlineCount,
      offlineCount,
      perOffline
    };
  }

  hourDayValue(): string | undefined {
    return this.hourDayArray.find(item => item.key === this.selectedHour)?.value;
  }

  onChartViewTogle() {
    if (this.isLoading) {
      this.createGraphs();
    }
  }

  onHostwiseToggle() {
    if (this.isLoading) {
      this.createGraphs();
    }
  }

  closeModal(schema: string) {
    if (schema === 'chartData') {
      this.showModal = false;
    } else {
      this.showSchemaModal[schema] = false;
    }
    this.modalData = [];
  }

  getLoginData() {
    if (this.selectedSchema.length === 0) {
      this.toaster.error('Please select a Schema');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.selectedDay)) {
      this.toaster.error('Please select a Time Interval');
      return;
    }
    const pktData = {
      eventIds: ['ERS_TOTAL_LOGIN'],
      isLogin: true,
      lastHrs: this.selectedDay,
      schemaKeys: this.selectedSchema,
      hostWise: this.hostWise
    };
    this.posHttpSvcs.authPost('v1/ui/loadERSLogin', 'loadERSLogin', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error('Invalid Data');
        return;
      }
      this.chartData = resp.data.data;
      this.loginDataService.setChartData(this.chartData);
      this.loginDataService.createCharts(this.elementRef);
    }));
    this.isLoading = true;
  }

  minDayValue(): string | undefined {
    return this.minHourArray.find(item => item.key === this.selectedClock)?.value;
  }

  getOffClock() {
    if (this.selectedApp.length === 0) {
      this.toaster.error('Please select a Schema');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.selectedClock)) {
      this.toaster.error('Please select a Time Range');
      return;
    }
    const pktData = {
      lastHrs: this.selectedClock,
      schemaKeys: this.selectedApp
    };
    this.posHttpSvcs.authPost('v1/ui/loadOffClock', 'loadOffClock', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error('Invalid Data');
        return;
      }
      this.clockData = resp.data;
    }));
    this.isLoading = true;

  }

  getOfflineClock() {
    if (this.selectedApp.length === 0) {
      this.toaster.error('Please select a Schema');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.timeEvent) && !this.chartView) {
      this.toaster.error('Please select a Time Interval');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.selectedHour) && this.chartView) {
      this.toaster.error('Please select a Time Range');
      return;
    }
    const pktData = {
      lastHrs: this.chartView ? this.selectedHour : this.timeEvent,
      chartView: this.chartView,
      schemaKeys: this.selectedApp
    };
    this.posHttpSvcs.authPost('v1/ui/loadOfflineClock', 'loadOfflineClock', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error('Invalid Data');
        return;
      }
      else if (this.chartView) {
        this.clockGraph = resp.data;
        this.offlineClockService.setOfflineData(this.clockGraph);
        this.offlineClockService.createCharts(this.elementRef)
      } else {
        this.clockStatusData = resp.data;
        this.selectedDayMinValue = resp.data[0].reportTime;
      }
    }));
    this.isLoading = true;

  }

  downloadCsv() {
    const headers = ['Schema', 'Total', 'Online', 'Offline', 'Offline Percentage'];
    const csvData = this.clockStatusData.map(row => [
      row.schemaID, row.totalCount, row.onlineCount, row.offlineCount, row.perOffline
    ]);

    csvData.push([
      this.totalRow.schemaID,
      this.totalRow.totalCount,
      this.totalRow.onlineCount,
      this.totalRow.offlineCount,
      this.totalRow.perOffline
    ]);

    let csvContent = 'data:text/csv;charset=utf-8,';
    csvContent = csvContent + headers.join(',') + '\n';
    csvContent = csvContent + csvData.map(e => e.join(',')).join('\n');

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'clock_status_report.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  get isHourlyDataEmpty(): boolean {
    return Object.keys(this.hourlyData).length === 0;
  }

  getHourlyGraphs() {
    if (this.selectedSchema.length === 0) {
      this.toaster.error('Please select a Schema');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.selectedEvent)) {
      this.toaster.error('Please select an Event');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.selectedDay)) {
      this.toaster.error('Please select a Time Interval');
      return;
    }
    const pktData = {
      eventIds: [this.selectedEvent],
      isLogin: true,
      lastHrs: this.selectedDay,
      schemaKeys: this.selectedSchema,
      hostWise: false
    };
    this.posHttpSvcs.authPost('v1/ui/loadERSLogin', 'loadERSLogin', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error('Invalid Data');
        return;
      }
      this.hourlyData = resp.data.data;
      this.hourlyGraphsService.setHourlyData(this.hourlyData);
      this.hourlyGraphsService.createCharts(this.elementRef, this.selectedEvent);
    }));
    this.isLoading = true;
  }

  get hasDailyData(): boolean {
    return Object.keys(this.dailyData).length > 0;
  }

  getDailyGraphs() {
    if (this.fnutilservice.isEmptyObject(this.selectedDailySchema)) {
      this.toaster.error('Please select a Schema');
      return;
    }
    if (!this.customDate && this.fnutilservice.isEmptyObject(this.selectedRange)) {
      this.toaster.error('Please select custom date');
      return;
    }
    const pktData = {
      id: this.selectedEvent,
      schema: this.selectedDailySchema,
      customDate: this.customDate,
      ...(this.customDate
        ? { startDate: this.startDate, endDate: this.endDate }
        : { selectedRange: this.selectedRange })

    };
    this.posHttpSvcs.authPost('v1/ui/getDailyGraphs', 'getDailyGraphs', pktData).subscribe(resp => {
      if (!resp.data.success) {
        this.toaster.error('Invalid Data');
        return;
      }
      this.dailyData = resp.data.data.chartData;
      this.dailyGraphsService.setChartData(this.dailyData);
      this.dailyGraphsService.createCharts(this.elementRef, this.selectedDailySchema, this.selectedEvent);
    });
    this.isLoading = true;
  }

  get totalAppRow(): AppRestartReport {
    const count = this.appRestartData.reduce((sum, item) => sum + item.count, 0);
    const weightedSum = this.appRestartData.reduce((sum, item) => {
      return sum + item.count * item.average;
    }, 0);

    const average = count ? parseFloat((weightedSum / count).toFixed(2)) : 0;

    return {
      schemaID: 'Total',
      count,
      average
    };
  }

  get totalHostRow(): HostRestartReport {
    const count = this.appRestartHost.reduce((sum, item) => sum + item.count, 0);
    const weightedSum = this.appRestartHost.reduce((sum, item) => {
      return sum + item.count * item.avg;
    }, 0);

    const avg = count ? parseFloat((weightedSum / count).toFixed(2)) : 0;

    return {
      hostName: 'Total',
      count,
      avg
    };
  }

  getAppRestart() {
    if (this.selectedApp.length === 0) {
      this.toaster.error('Please select a Schema');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.selectedHour)) {
      this.toaster.error('Please select a Time Interval');
      return;
    }
    const pktData = {
      lastHrs: this.selectedHour,
      schemaKeys: this.selectedApp
    };
    this.posHttpSvcs.authPost('v1/ui/loadAppRestart', 'loadAppRestart', pktData).subscribe(resp => {
      if (resp.isError) {
        this.toaster.error('Invalid Data');
        this.isLoading = false;
        return;
      }

      this.appRestartData = resp.data.tableData || [];
      this.appRestartHost = resp.data.hostWiseData || [];
      this.hostWiseGraphData = resp.data.hostWiseData || [];
      this.chartDataGraph = resp.data.chartData || [];

      const schemaKeys = Object.keys(resp.data).filter(key =>
        !['hostWiseData', 'chartData', 'tableData'].includes(key)
      );
      this.schemaGraphData = schemaKeys.map(key => ({
        schema: key,
        timeWise: resp.data[key].timeWise || [],
        hostWise: resp.data[key].hostWise || []
      }));

      this.showSchemaModal = {};
      this.schemaGraphData.forEach(sg => {
        this.showSchemaModal[sg.schema] = false;
      });

      this.createGraphs();
    });
    this.isLoading = true;
  }

  parseHostSet(hostSet: string): { hostName: string; count: number }[] {
    if (!hostSet) return [];
    return hostSet
      .split('\n')
      .filter(entry => entry.trim())
      .map(entry => {
        const [hostName, countStr] = entry.split('->');
        return {
          hostName: hostName.trim(),
          count: parseInt(countStr.trim(), 10) || 0
        };
      });
  }

  createGraphs() {
    const chartContainer = this.elementRef.nativeElement.querySelector('#app_restart');
    if (!chartContainer) {
      console.error('Chart container not found');
      return;
    }
    chartContainer.innerHTML = '';

    if (this.chartView) {
      if (this.hostwise) {
        if (this.hostWiseGraphData.length > 0) {
          const hostWiseDiv = document.createElement('div');
          hostWiseDiv.style.width = '100%';
          hostWiseDiv.style.height = '400px';
          hostWiseDiv.style.marginBottom = '20px';
          chartContainer.appendChild(hostWiseDiv);
          this.appRestartService.createHostWiseGraph(hostWiseDiv, this.hostWiseGraphData, 'Host Wise Data');
        }

        if (this.chartDataGraph.length > 0) {
          const chartDataDiv = document.createElement('div');
          chartDataDiv.style.width = '100%';
          chartDataDiv.style.height = '400px';
          chartDataDiv.style.marginBottom = '20px';
          chartContainer.appendChild(chartDataDiv);
          this.appRestartService.createTimeWiseGraph(chartDataDiv, this.chartDataGraph, 'Chart Data', (hostSet: string) => {
            this.modalData = this.parseHostSet(hostSet);
            this.showModal = true;
            setTimeout(() => {
              const modalChartContainer = this.elementRef.nativeElement.querySelector('#modal-chart');
              if (modalChartContainer && this.modalData.length > 0) {
                this.appRestartService.createModalChart(modalChartContainer, this.modalData);
              }
            }, 0);
          });
        }
      } else {
        this.schemaGraphData.forEach(sg => {
          if (sg.timeWise.length > 0) {
            const timeWiseDiv = document.createElement('div');
            timeWiseDiv.style.width = '100%';
            timeWiseDiv.style.height = '400px';
            timeWiseDiv.style.marginBottom = '20px';
            chartContainer.appendChild(timeWiseDiv);
            this.appRestartService.createTimeWiseGraph(timeWiseDiv, sg.timeWise, `Schema: ${sg.schema} (Time Wise)`, (hostSet: string) => {
              this.modalData = this.parseHostSet(hostSet);
              this.showSchemaModal[sg.schema] = true;
              setTimeout(() => {
                const modalChartContainer = this.elementRef.nativeElement.querySelector(`#modal-chart-${sg.schema}`);
                if (modalChartContainer && this.modalData.length > 0) {
                  this.appRestartService.createModalChart(modalChartContainer, this.modalData);
                }
              }, 0);
            });
          }
          if (sg.hostWise.length > 0) {
            const hostWiseDiv = document.createElement('div');
            hostWiseDiv.style.width = '100%';
            hostWiseDiv.style.height = '400px';
            hostWiseDiv.style.marginBottom = '20px';
            chartContainer.appendChild(hostWiseDiv);
            this.appRestartService.createHostWiseGraph(hostWiseDiv, sg.hostWise, `Schema: ${sg.schema} (Host Wise)`);
          }
        });
      }
    }
  }

  isClockHighlighted(schema: string): boolean {
    const highlightedSchemas = this.siteClockData.map(item => item.schemaID);
    return highlightedSchemas.includes(schema);
  }

  get totalSiteRow(): SiteClockReport {
    const count = this.siteClockData.reduce((sum, item) => sum + item.count, 0);
    return {
      schemaID: 'Total',
      count
    };
  }

  getSiteClock() {
    if (this.selectedApp.length === 0) {
      this.toaster.error('Please select a Schema');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.timeEvent) && !this.siteChartView) {
      this.toaster.error('Please select a Time Interval');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.selectedHour) && this.siteChartView) {
      this.toaster.error('Please select a Time Range');
      return;
    }
    const pktData = {
      lastHrs: this.siteChartView ? this.selectedHour : this.timeEvent,
      chartView: this.siteChartView,
      schemaKeys: this.selectedApp
    };
    this.posHttpSvcs.authPost('v1/ui/loadSiteClock', 'loadSiteClock', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error('Invalid Data');
        return;
      }
      else if (this.siteChartView) {
        this.siteGraph = resp.data;
        this.siteClockService.setSiteClockData(this.siteGraph);
        this.siteClockService.createCharts(this.elementRef)
      } else {
        this.siteClockData = resp.data;
        this.selectedDayMinValue = resp.data[0].reportTime;
      }
    }));
    this.isLoading = true;
  }

  get hasHostData(): boolean {
    return Object.keys(this.hostData).length > 0;
  }

  getContextEvent() {
    if (this.selectedSchema.length === 0) {
      this.toaster.error('Please select a Schema');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.selectedDay)) {
      this.toaster.error('Please select a Time Interval');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.selectedHostEvent)) {
      this.toaster.error('Please select an Event');
      return;
    }
    const pktData = {
      eventIds: [this.selectedHostEvent],
      isLogin: false,
      lastHrs: this.selectedDay,
      schemaKeys: this.selectedSchema,
    };
    this.posHttpSvcs.authPost('v1/ui/loginAverageWithHost', 'loginAverageWithHost', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error('Invalid Data');
        return;
      }
      this.hostData = resp.data;
      this.contextEventService.setChartData(this.hostData);
      this.contextEventService.createCharts(this.elementRef, this.selectedHostEvent);
    }));
    this.isLoading = true;
  }

  timeEvent: any;
  changeEventDate(event: any) {
    const date = new Date(event);

    const formatted = `${(date.getMonth() + 1).toString().padStart(2, '0')}/` +
      `${date.getDate().toString().padStart(2, '0')}/` +
      `${date.getFullYear()} ` +
      `${date.getHours().toString().padStart(2, '0')}:` +
      `${date.getMinutes().toString().padStart(2, '0')}:` +
      `${date.getSeconds().toString().padStart(2, '0')}`;

    this.timeEvent = formatted;
  }

}
interface ChartDataPoint {
  schema?: string;
  avg: number;
  busiDate?: string;
  count: number;
  index?: number;
  time: string;
  id?: string;
  hostWiseCount?: string;
  serverMapList?: any[];
  color?: string;
}

interface ClockStatusReport {
  schemaID: string;
  totalCount: number;
  onlineCount: number;
  offlineCount: number;
  perOffline: number;
}

interface SiteClockReport {
  schemaID: string;
  count: number;
}

interface AppRestartReport {
  schemaID: string;
  count: number;
  average: number;
}

interface HostRestartReport {
  hostName: string;
  count: number;
  avg: number;
}
